import { useDndContext } from "@dnd-kit/core";
import { TableColumnType } from "components/UI/Table/types/table";
import React from "react";
import { Identifiable } from "types/models";

interface DragPreviewProps<T extends Identifiable> {
    columns: TableColumnType<T>[];
    dataSource: T[];
}

export function DragPreview<T extends Identifiable>({ columns, dataSource }: DragPreviewProps<T>) {
    const { active } = useDndContext();
    if (!active) return null;

    const record = (active.data?.current?.record as T | undefined) ?? dataSource.find((item) => item.id === active.id);

    if (!record) return null;

    return (
        <div className="w-[800px] overflow-hidden rounded-md shadow-lg">
            <table className="w-full bg-white text-black border border-gray-300">
                <tbody>
                    <tr>
                        {columns.map((col) => {
                            const key = String(col.dataIndex);
                            const value = (record as any)[col.dataIndex as keyof T];
                            const cellContent: React.ReactNode = col.render
                                ? (col.render(value, record, 0) as React.ReactNode)
                                : (String(value ?? "") as React.ReactNode);

                            return (
                                <td key={key} className="px-3 py-2 border border-gray-200 text-sm truncate">
                                    {cellContent}
                                </td>
                            );
                        })}
                    </tr>
                </tbody>
            </table>
        </div>
    );
}
